import { createSelector } from '@reduxjs/toolkit';

// Models
import { IBillingState } from './billing.slice';
import { TRootState } from '../index';

/**
 A selector function to retrieve the billing data from the store
 @function
 @param {TRootState} state - The root state of the Redux store
 @returns {IBillingState} The billing state object from the Redux store
 */
const selectBillingState = (state: TRootState): IBillingState => state.billing;

/**
 A memoized selector function to retrieve the billing data from the store
 @function
 @type {import('@reduxjs/toolkit').OutputSelector<RootState, IBillingState, (res: IBillingState) => IBillingState>}
 */
export const getBillingState = createSelector(
  [selectBillingState],
  (state): IBillingState => state
);
